/**
 * TimelineContentReportMarkers Component
 *
 * Renders user-submitted report date lines extending through the content area.
 * Solid vertical lines coloured by report type (distinct from the dashed frost lines).
 */

import React, { useMemo } from 'react'
import { useTimelineStaticContext } from '../../context/timeline-static-context'
import { useTimelineInteractionContext } from '../../context/timeline-interaction-context'

/**
 * TimelineContentReportMarkers - Report date lines in content
 *
 * Extends the report markers from the header through the entire content area.
 */
export const TimelineContentReportLines = React.memo(() => {
  const { FROST_DATES, REPORT_DATES } = useTimelineStaticContext()
  const { hoveredReportIndex } = useTimelineInteractionContext()
  const dates = useMemo(() => [...FROST_DATES, ...REPORT_DATES], [FROST_DATES, REPORT_DATES])

  if (!dates?.length) return null

  return (
    <>
      {dates.map((date, i) => (
        <line
          key={`report-line-${i}`}
          x1={date.x}
          y1={0}
          x2={date.x}
          y2="100%"
          stroke={date.color}
          strokeWidth={hoveredReportIndex === i ? 2 : 1}
          style={{ pointerEvents: 'none', transition: 'x1 0.3s, x2 0.3s' }}
          opacity={0.6}
          {...(date.dash ? { strokeDasharray: date.dash } : {})}
        />
      ))}
    </>
  )
})
